import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { MatDialog } from '@angular/material';
import { DialogCreateExchangeCodeComponent } from '../dialog-create-exchange-code/dialog-create-exchange-code.component';
import { Subscription } from 'rxjs';
import { StorageService } from '../../../service/service.index';


@Component({
  selector: 'app-point',
  templateUrl: './point.component.html',
  styleUrls: ['./point.component.scss']
})
export class PointComponent implements OnInit, OnDestroy {

  totalAmount: number;
  suscription: Subscription = new Subscription();
  columnsPoint = ['dateCreated', 'point'];
  dataSourcePoint = new MatTableDataSource<any>();
  amountAvailible: number = 500;
  active: boolean;

  @Input() set changePoints(points: any[]) {
    this.dataSourcePoint.data = points;


  }


  constructor(public dialog: MatDialog, private _srvStorage: StorageService) {

    this.totalAmount = this._srvStorage.showAmount;

    this.active = ( this.totalAmount > 0 ) ? true : false;
  }


  ngOnInit() {
  }


  ngOnDestroy() {
    this.suscription.unsubscribe();
  }


  createExchangeCode() {

    const DIALOG_REF = this.dialog.open(DialogCreateExchangeCodeComponent, {
      // width: '750px',
      height: '400px',
      autoFocus: false,
      disableClose: true,
      data: this.totalAmount
    });


    this.suscription.add(
      DIALOG_REF.afterClosed().subscribe(response => {
        console.log(response);
        this.totalAmount = response;
      })
    );
  }


}


